export const LABEL_SITUATION = {
  EM_USE: 'Em uso',
  DISPONIVEL: 'Disponível',
  DESCARTE: 'Descarte',
} as const;

export const LABEL_SITUATION_EXIT_SST = {
  EM_USE: 'Em uso',
  DESCARTE: 'Descarte',
} as const;
